import type {
  AgentChatResponsePartClientEvent,
  AgentResponse,
  AgentResponseCorrection,
  AgentToolResponseClientEvent,
  AgentToolResponseFullPayloadClientEvent,
  AsrInitiationMetadataEvent as AsrMetadataEvent,
  Audio,
  AgentToolRequestClientEvent,
  ClientToolCallMessage,
  ConversationMetadata,
  ErrorMessage,
  GuardrailTriggered,
  Interruption,
  McpConnectionStatusClientEvent,
  McpToolCall,
  Outgoing,
  Ping,
  InternalTentativeAgentResponse as TentativeAgentResponseInternal,
  UserTranscript,
  VadScore,
} from "@elevenlabs/types";
import type { AudioAlignmentEvent } from "../types.js";

// Compatibility layer - incoming events
export type UserTranscriptionEvent = UserTranscript;
export type AgentResponseEvent = AgentResponse;
export type AgentAudioEvent = Audio;
export type InterruptionEvent = Interruption;
export type InternalTentativeAgentResponseEvent =
  TentativeAgentResponseInternal;
export type ConfigEvent = ConversationMetadata;
export type PingEvent = Ping;
export type ClientToolCallEvent = ClientToolCallMessage;
export type VadScoreEvent = VadScore;
export type MCPToolCallClientEvent = McpToolCall;
export type AgentResponseCorrectionEvent = AgentResponseCorrection;
export type AgentToolRequestEvent = AgentToolRequestClientEvent;
export type AgentToolResponseEvent = AgentToolResponseClientEvent;
export type AgentToolResponseFullPayloadEvent =
  AgentToolResponseFullPayloadClientEvent;
export type ConversationMetadataEvent = ConversationMetadata;
export type AsrInitiationMetadataEvent = AsrMetadataEvent;
export type MCPConnectionStatusEvent = McpConnectionStatusClientEvent;
export type AgentChatResponsePartEvent = AgentChatResponsePartClientEvent;
export type ErrorMessageEvent = ErrorMessage;
export type GuardrailTriggeredEvent = GuardrailTriggered;
export type { AudioAlignmentEvent };

export type IncomingSocketEvent =
  | UserTranscriptionEvent
  | AgentResponseEvent
  | AgentResponseCorrectionEvent
  | AgentAudioEvent
  | InterruptionEvent
  | InternalTentativeAgentResponseEvent
  | ConfigEvent
  | PingEvent
  | ClientToolCallEvent
  | VadScoreEvent
  | MCPToolCallClientEvent
  | AgentToolRequestEvent
  | AgentToolResponseEvent
  | AgentToolResponseFullPayloadEvent
  | ConversationMetadataEvent
  | AsrInitiationMetadataEvent
  | MCPConnectionStatusEvent
  | AgentChatResponsePartEvent
  | ErrorMessageEvent
  | GuardrailTriggeredEvent;

// Compatibility layer - outgoing events
export type PongEvent = Outgoing.PongClientToOrchestratorEvent;
export type UserAudioEvent = Outgoing.UserAudio;
export type UserFeedbackEvent = Outgoing.UserFeedbackClientToOrchestratorEvent;
export type ClientToolResultEvent =
  Outgoing.ClientToolResultClientToOrchestratorEvent;
export type InitiationClientDataEvent =
  Outgoing.ConversationInitiationClientToOrchestratorEvent;
export type ContextualUpdateEvent =
  Outgoing.ContextualUpdateClientToOrchestratorEvent;
export type UserMessageEvent = Outgoing.UserMessageClientToOrchestratorEvent;
export type UserActivityEvent = Outgoing.UserActivityClientToOrchestratorEvent;
export type MCPToolApprovalResultEvent =
  Outgoing.McpToolApprovalResultClientToOrchestratorEvent;
export type MultimodalMessageEvent =
  Outgoing.MultimodalMessageClientToOrchestratorEvent;

export type OutgoingSocketEvent =
  | PongEvent
  | UserAudioEvent
  | InitiationClientDataEvent
  | UserFeedbackEvent
  | ClientToolResultEvent
  | ContextualUpdateEvent
  | UserMessageEvent
  | UserActivityEvent
  | MCPToolApprovalResultEvent
  | MultimodalMessageEvent;

export function isValidSocketEvent(event: any): event is IncomingSocketEvent {
  return !!event.type;
}
